module.exports = __webpack_public_path__ + "../resources/img/qr-ios-go.97f71113.png";